<form [formGroup]="ruleConfigureFormGroup">
    <div class="approval_card_details div-wrapper lookup-wrapper">
        <div class="approval_card_titles">
            <h4>
                {{ 'SETTING_PAGE.IDMS_SETTINGS.CONFIGURE' | transloco }} <span *ngIf="selectedRule?.name">{{ selectedRule?.name }}</span
                ><button class="mat-tooltip-trigger btn primary-ebtn" (click)="ManageDeliveryGroup()" *ngIf="iscreateRule && iseditRule">
                    {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_EDIT_DELIVERY_GROUPS' | transloco }}
                </button>
            </h4>
        </div>

        <div class="code_details_inside card_text_center" *ngIf="!selectedRule?.approvalRuleId && selectedRule?.approvalRuleId != '0'">
            <div class="configure-wrap">
                <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_OR_SELECT_RULE_TO_CONFIGURE' | transloco }}</h3>
            </div>
        </div>
        <div class="approval_card_section" *ngIf="selectedRule?.approvalRuleId || selectedRule?.approvalRuleId == '0'">
            <div class="h2cls">
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-center ruleEnabled">
                            <!-- <p-selectbutton
                                [options]="stateOptions"
                                formControlName="enabled"
                                optionLabel="label"
                                optionValue="value"
                                (onChange)="toggleSwitch($event)"
                            >
                            </p-selectbutton> -->
                            <p-selectbutton
                                [options]="stateOptions"
                                formControlName="enabled"
                                optionLabel="label"
                                optionValue="value"
                                (onChange)="toggleSwitch($event)"
                            >
                                <ng-template #item let-option>
                                    <span>{{ option.label }}</span>
                                </ng-template>
                            </p-selectbutton>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <div class="label-select-wrap">
                            <label class="label-inline">{{ 'SETTING_PAGE.IDMS_SETTINGS.WHEN' | transloco }}</label>

                            <mat-select formControlName="trigger" class="mat-select-general input-form-class" (selectionChange)="selectLookUp($event)">
                                <mat-option class="option-list" [value]="item.key" *ngFor="let item of triggers">{{ item.value }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-1"></div>
                    <div class="col-md-5">
                        <div class="label-select-wrap">
                            <label class="label-inline">{{ 'SETTING_PAGE.IDMS_SETTINGS.A' | transloco }}</label>

                            <mat-select (selectionChange)="itemSelect($event)" formControlName="item" class="mat-select-general input-form-class">
                                <mat-option class="option-list" [value]="item.key" *ngFor="let item of items">{{ item.value }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-5">
                        <div class="label-select-wrap">
                            <label class="label-inline">{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFY' | transloco }}</label>
                            <mat-select
                                (selectionChange)="deliveryGroupselect($event)"
                                multiple
                                style="margin-bottom: 10px; border-bottom: none"
                                formControlName="groups"
                                class="mat-select-general input-form-class"
                            >
                                <mat-option *ngFor="let item of deliveryGroups" [value]="item.key">
                                    {{ item.value }}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-5">
                        <div class="label-select-wrap">
                            <label class="label-inline">{{ 'SETTING_PAGE.IDMS_SETTINGS.TO' | transloco }}</label>
                            <mat-select (selectionChange)="actionSelect($event)" formControlName="action" class="mat-select-general input-form-class">
                                <mat-option class="option-list" *ngFor="let item of actions" [value]="item.key">{{ item.value }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
